import {
  doc,
  getDoc,
  increment,
  serverTimestamp,
  setDoc,
} from "firebase/firestore";
import { getFirestoreDb, logAnalyticsEvent } from "../monitoring/firebase";
import { reportError } from "../monitoring/reportError";

const CV_DOWNLOADS_DOC = ["stats", "cvDownloads"];

const isProduction = process.env.NODE_ENV === "production";

const cvDownloadsRef = (db) => doc(db, ...CV_DOWNLOADS_DOC);

export async function getCvDownloadCount() {
  const db = getFirestoreDb();
  if (!db) {
    return null;
  }

  try {
    const snapshot = await getDoc(cvDownloadsRef(db));
    if (!snapshot.exists()) {
      return 0;
    }
    return snapshot.data().count ?? 0;
  } catch (error) {
    reportError(error, { fatal: false, source: "cv.tracking.read" });
    return null;
  }
}

export async function trackCvDownload() {
  if (!isProduction) {
    return null;
  }

  logAnalyticsEvent("cv_download");

  const db = getFirestoreDb();
  if (!db) {
    return null;
  }

  try {
    await setDoc(
      cvDownloadsRef(db),
      {
        count: increment(1),
        updatedAt: serverTimestamp(),
      },
      { merge: true }
    );
    return getCvDownloadCount();
  } catch (error) {
    reportError(error, { fatal: false, source: "cv.tracking.write" });
    return null;
  }
}
